import { SupportEnvironment } from '@app/multi-environment/support-environment'

// Staging is left out on purpose: Atlas watches the environments that carry customer traffic.
//
// Every entry has to stay on a *.wiseworks.ai subdomain. The session cookie is SameSite=Lax, which
// is sent here only because these are the same site as Atlas itself; an environment moved to a
// customer's own domain would become invisible to Atlas rather than merely needing a sign-in.
export const ATLAS_ENVIRONMENTS: SupportEnvironment[] = [
  { key: 'prod', label: 'Production', origin: 'https://app.wiseworks.ai' },
  { key: 'arendt', label: 'Arendt', origin: 'https://arendt.wiseworks.ai' },
  { key: 'athora', label: 'Athora', origin: 'https://athora.wiseworks.ai' },
  { key: 'aviva', label: 'Aviva', origin: 'https://aviva.wiseworks.ai' },
  { key: 'eccles', label: 'Ecclesiastical', origin: 'https://ecclesiastical.wiseworks.ai' },
  { key: 'schroders', label: 'Schroders', origin: 'https://schroders.wiseworks.ai' },
  { key: 'sjp', label: 'SJP', origin: 'https://sjp.wiseworks.ai' },
]
